module.exports = __webpack_public_path__ + "static/media/icon_operaciones.ce240cc9.png";